exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.UserSettings--web{background-color:#fff;max-width:375px;height:400px}.UserSettings .user-settings-header{display:flex;justify-content:center;align-items:center;width:100%;height:64px;background-color:#000}.UserSettings .user-settings-header__text{color:#fff;font-family:Oswald,sans-serif;margin:0;font-size:18px}.UserSettings .expandable-section{border-bottom:none}.UserSettings .expandable-section__name{font-family:Oswald,sans-serif;font-size:24px;font-weight:300;line-height:1;color:#9b9b9b}.UserSettings .expandable-section__content{margin-top:4px}.UserSettings .user-settings-button{margin:40px 0 0 290px;border:none;color:#fff;background-color:#184e78;width:70px;height:28px;font-weight:600;border-radius:4px}.UserSettings .user-settings-button:hover{cursor:pointer}.UserSettings .user-settings-button:focus{outline:none}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/UserSettings/UserSettings.scss
// module id = 1682
// module chunks = 0